import {useRoomConfig} from "../RoomConfigContext";
import {useMemo} from "react";
import {getProjectorDistances} from "../utils/projectorUtils";
import {ScreenType} from "../../config/ScreenConfig";

export const useProjectorPosition = (config, screenSize) => {
    const {height, roofHeight, freeDepth} = useRoomConfig();

    return useMemo(() => {
        const dists = getProjectorDistances(config, screenSize);
        const roomEdge = freeDepth - config.size[2];
        const distance = Math.min(dists[2], roomEdge);
        // use cupboard height
        const y = config.type === ScreenType.UltraShortThrow? 35 : height > 200? height : height < 200? 200 : height + roofHeight > 200? 200 : height + roofHeight;

        return {
            position: [0, y, -distance],
            rotation: config.type === ScreenType.UltraShortThrow? Math.PI : 0
        };
    }, [height, roofHeight, freeDepth, screenSize, config]);
}
